import React, { memo } from 'react'
import { Handle, Position } from '@xyflow/react'

const AddButton = memo(({ data }) => {
    return (
        <div className="wf-add-button">
            <Handle type="target" position={Position.Top} className="wf-handle wf-handle-hidden" />
            <div className="wf-add-button-inner">
                <i className="fa fa-plus" /> {data.label}
            </div>
            <Handle type="source" position={Position.Bottom} className="wf-handle wf-handle-hidden" />
        </div>
    )
})

AddButton.displayName = 'AddButton'
export default AddButton
